module.exports = __webpack_public_path__ + "static/media/mom.65106d98.png";